<div class="login-form-flex">
    <mat-card appearance="outlined" class="single">
        <mat-card-header>
            <mat-card-title (click)="cheat()">{{ 'login.login.title' | translate }}</mat-card-title>
        </mat-card-header>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <mat-card-content>
                <mat-form-field class="field">
                    <mat-label>{{ 'login.login.form.email' | translate }}</mat-label>
                    <input matInput
                           required
                           type="text"
                           id="email"
                           formControlName="email"
                           class="form-control"
                           [ngClass]="{ 'is-invalid': submittedAtLeastOnce && f.email.errors }"/>
                    @if (submittedAtLeastOnce && f.email.errors) {
                        <mat-error class="invalid-feedback">
                            @if (f.email.errors.maxlength) {
                                <span>
                  {{ 'login.validation.email.maxLength' | translate: {maxLength: this.maxLength} }}
                </span>
                            }
                            @if (f.email.errors.email) {
                                <span>
                  {{ 'login.validation.email.valid' | translate }}
                </span>
                            }
                        </mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="field">
                    <mat-label>{{ 'login.login.form.password' | translate }}</mat-label>
                    <input matInput
                           required
                           type="password"
                           id="password"
                           formControlName="password"
                           class="form-control"
                           [ngClass]="{ 'is-invalid': submittedAtLeastOnce && f.password.errors }"/>
                    @if (submittedAtLeastOnce && f.password.errors) {
                        <mat-error class="invalid-feedback">
                            @if (f.password.errors.maxlength) {
                                <span>
                                    {{ 'login.validation.password.maxLength' | translate: {maxLength: this.maxLength} }}
                                </span>
                            }
                        </mat-error>
                    }
                </mat-form-field>
                @if (submittedAtLeastOnce && f.password.errors) {
                    <mat-error class="invalid-feedback">
                        @if (f.password.errors.wrong) {
                            <span>{{ "login.login.invalidCredentials" | translate }}</span>
                        }
                    </mat-error>
                }
            </mat-card-content>
            <mat-card-actions class="centered-button-container">
                <div class="button-flex-container">
                    <button mat-raised-button color="primary" [disabled]="waitingForResponse">
                        {{ "login.login.button.login" | translate }}
                    </button>
                    <br/><br/>
                    <button mat-button (click)="passwordForgotten()">
                        {{ 'login.login.button.passwordForgotten' | translate }}
                    </button>
                    <div class="font-overline">V{{ portalVersion }}</div>
                </div>
            </mat-card-actions>
        </form>
    </mat-card>
</div>

